import omit from "lodash/omit";
import api from "PFCore/api";
import { Id } from "PFCore/types";
import { KPIStatus } from "PFCore/types/kpi";

export type CreateKPIReviewPayload = {
  indicatorId: Id;
  engagementId: Id;
  status: KPIStatus.ApprovalRequested | KPIStatus.ApprovalGranted | KPIStatus.ApprovalRejected;
  comment?: string;
};

export const createKPIReview = (data: CreateKPIReviewPayload) =>
  api({
    url: `engagements/${data.engagementId}/kpi_reviews`,
    method: "POST",
    data: omit(data, "engagementId")
  });
